<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6"
        v-for="item in items"
        :key="item.name"
      >
        <v-card :to="{ name: item.to }">
          <v-img
            :src="item.photo"
            height="200"
            width="100%"
          />
          <v-card-title primary-title>
            {{ item.name }}
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable global-require */
export default {
  name: 'Home',
  module: 'StockItem',
  data() {
    return {
      items: [{
        name: this.$$t('deliveryNotes'),
        photo: require('../assets/chuttersnap-sxhVoUrItmQ-unsplash.jpg'),
        to: 'processing-ListDeliveryNote',
      }, {
        name: this.$$t('stock'),
        photo: require('../assets/arno-senoner-yqu6tJkSQ_k-unsplash.jpg'),
        to: 'processing-ListStockItem',
      }, {
        name: this.$$t('factoryItems'),
        photo: require('../assets/milo-weiler-yLArTj2kIMg-unsplash.jpg'),
        to: 'processing-ListFactoryItem',
      }, {
        name: this.$$t('farms'),
        photo: require('../assets/frances-gunn-QcBAZ7VREHQ-unsplash.jpg'),
        to: 'processing-ListFarm',
      }, {
        name: this.$$t('brands'),
        photo: require('../assets/nico-smit-PTv-B97DHNI-unsplash.jpg'),
        to: 'processing-ListBrand',
      }],
    };
  },
};
</script>
